import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { LoginForm, useAuth } from "../../components";
import { LoginFormValues } from "../../components/forms/login/LoginForm";
import { publicCustomerUserClient } from "../../api";
import InviteHeading from "./components/InviteHeading";
import {
  saveAccessToken,
  saveRefreshToken,
  saveRefreshTokenId,
} from "../../helpers/tokenManager";
import { useNavigate, useParams } from "react-router";
import { InviteRouteParams } from "./models";

const InviteLoginPage: React.FC = (): React.ReactElement => {
  const { setUser, setOtherAccounts, setAuthenticated } = useAuth();

  const { tInvite } = useCustomTranslation();
  const navigate = useNavigate();
  const params = useParams<InviteRouteParams>();

  const handleSubmit = async (values: LoginFormValues) => {
    const result = await publicCustomerUserClient.login(values);

    if (result.success && result.customerUser) {
      saveRefreshToken(result.refreshToken);
      saveRefreshTokenId(result.refreshTokenId);
      saveAccessToken(result.accessToken);
      setUser(result.customerUser);
      setOtherAccounts(result.contactPeople);
      setAuthenticated(true);

      await navigate(
        `/${params.tenantCode}/invite/${params.invitationGuid}/accept`,
      );
    }
  };

  return (
    <ContentWrapper largePadding htmlTitle={tInvite("html_title")}>
      <InviteHeading />
      <div className="mt-4">
        <p className="my-3">{tInvite("accept_with_existing_account")}</p>
        <LoginForm onSubmit={handleSubmit} onInvitePage />
      </div>
    </ContentWrapper>
  );
};

export default InviteLoginPage;
